import { Injectable } from '@angular/core';
import { CoreOsVersion } from '@uigy/generated/graphql';
import { TranslationKey } from '@uigy/shared/services/language.service';
import { Texts } from '@language/interfaces/interfaces';

@Injectable({
  providedIn: 'root',
})
export class SensorsDataHelperService {

  public resolvePlatformName(platformType: CoreOsVersion): TranslationKey<`settings.system_config.sensors.platforms.${'ol8' | 'centos_7' | 'windows'}`, Texts> {
    switch (platformType) {
      case CoreOsVersion.Centos7:
        return 'settings.system_config.sensors.platforms.centos_7';
      case CoreOsVersion.Ol8:
        return 'settings.system_config.sensors.platforms.ol8';
      case CoreOsVersion.Windows:
        return 'settings.system_config.sensors.platforms.windows';
    }
  }
}
